<template>
    <div class="home">
        <div class="main flex flex-direction" :class="{fixed:!isScroll}">
            <router-view></router-view>
        </div>
        <div class="foot-box">
            <footPage/>
        </div>
    </div>
</template>
<script>
import footPage from "@/views/h5/common/footPage";

export default {
    name: "home",
    data() {
        return {
            headActive: ''
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        isScroll(){
            return this.$route.path.includes('/masses/index') || this.$route.path.includes('/masses/detail')
        }
    },
    components: {
        footPage
    },
    created() {

    },
    methods: {
        getActive(data) {
            if (data) {
                this.headActive = data.headActive
            }
        },
    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>
.home {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;

    .main {
        width: 100%;
        flex: 1;
        &.fixed{
            overflow: auto;
        }
    }

    .foot-box {
        width: 100%;
    }
}
</style>


